import { useIsMountedRef } from '@qodana/blocks/lib/hooks'
import { useCallback, useState } from 'react'

import { logout } from '../services/authorization'
import { AuthorizationEventGroup } from '../tracking/groups/authorization'

export const useLogout = (
	trackEvent: (...args: unknown[]) => void,
	redirectUrlPath?: string,
	callback?: (() => void) | (() => Promise<void>),
) => {
	const [isLogoutInProgress, setIsLogoutInProgress] = useState(false)
	const isMountedRef = useIsMountedRef()

	const handleLogout = useCallback(() => {
		setIsLogoutInProgress(true)

		trackEvent(AuthorizationEventGroup.events.logout())

		logout(redirectUrlPath).finally(() => {
			if (!isMountedRef.current) {
				return
			}

			if (callback) {
				Promise.resolve(callback()).finally(() => {
					if (isMountedRef.current) {
						setIsLogoutInProgress(false)
					}
				})
			} else {
				setIsLogoutInProgress(false)
			}
		})
	}, [isMountedRef, redirectUrlPath, trackEvent, callback])

	return [isLogoutInProgress, handleLogout] as const
}
